import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Menu,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { AiFillLock, AiFillUnlock, AiOutlineCopy } from "react-icons/ai";
import { IoCopy } from "react-icons/io5";
import { BiSolidImageAdd } from "react-icons/bi";
import { FcRemoveImage } from "react-icons/fc";
import { MdOutlineCleanHands } from "react-icons/md";
import { RiBringToFront, RiSendToBack } from "react-icons/ri";
import { RxDimensions } from "react-icons/rx";
import React, { useContext, useEffect, useState } from "react";
import { CanvasContext } from "../../Components/core/workspace/CanvasContext";
import { fabric } from "fabric";
import { HiTrash } from "react-icons/hi";

const ClickMenuList = () => {
  const { canvas } = useContext(CanvasContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [addDimension, setAddDimension] = useState({
    width: "",
    height: "",
  });
  // mouse control
  const [isRightMenuOpen, setIsRightMenuOpen] = useState(false);
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);

  // mouse click
  const handleMouseUp = (e) => {
    const pointer = canvas.getPointer(e);
    const target = canvas.findTarget(e, false);
    if (target) {
      if (!(target instanceof fabric.Textbox)) {
        // Deselect all objects
        canvas.discardActiveObject();

        // Select the target object
        canvas.setActiveObject(target);

        // Re-render the canvas
        canvas.requestRenderAll();
      }
    }
    setMouseX(e.e.clientX);
    setMouseY(e.e.clientY);
    e.e.preventDefault(true);
    if (e.e.buttons === 2) {
      setIsRightMenuOpen(true);
    }
  };
  useEffect(() => {
    if (canvas) {
      canvas.on("mouse:down", handleMouseUp);
    }
  }, [canvas]);
  const cleanCanvas = () => {
    canvas.clear();
    canvas.backgroundColor = "white";
  };

  const setBackgroud = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "image") {
      const dataUrl = activeObject["_element"].currentSrc;
      fabric.Image.fromURL(dataUrl, (img) => {
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height,
        });
        // Remove the image object from the canvas
        canvas.remove(activeObject);
      });
    }
  };
  const objectFitToCanvas = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "image") {
      const dataUrl = activeObject["_element"].currentSrc;
      fabric.Image.fromURL(dataUrl, function (img) {
        // Scale image to fit canvas
        var scaleX = canvas.getWidth() / img.width;
        var scaleY = canvas.getHeight() / img.height;
        var scale = scaleX < scaleY ? scaleX : scaleY;

        img.set({
          left: 0,
          top: 0,
          scaleX: scale,
          scaleY: scale,
        });
        canvas.remove(activeObject);
        canvas.add(img);
        canvas.requestRenderAll();
      });
    }
  };
  const changeCanvasDimension = (newWidth, newHeight) => {
    if (canvas) {
      canvas.setWidth(newWidth);
      canvas.setHeight(newHeight);
      canvas.calcOffset();
      canvas.renderAll();
      onClose();
    }
  };
  // for Dimension
  const handleDimension = (e) => {
    setAddDimension({ ...addDimension, [e.target.name]: e.target.value });
  };

  const deleteBackground = () => {
    canvas.setBackgroundImage(null, canvas.renderAll.bind(canvas));
  };

  const deleteItem = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.remove(activeObject);
    }
  };

  const copyItem = () => {
    let activeObject = canvas.getActiveObject();

    if (activeObject) {
      activeObject.clone((clonedObject) => {
        clonedObject.set({
          left: clonedObject.left + 10,
          top: clonedObject.top + 10,
        });
        canvas.add(clonedObject);
      });
    }
  };

  const sendBackward = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.sendBackwards(activeObject);
    }
    canvas.renderAll();
  };

  const bringForward = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.bringForward(activeObject);
    }
    canvas.renderAll();
  };

  const lockObject = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      activeObject.set({
        lockMovementX: true,
        lockMovementY: true,
        lockRotation: true,
        lockScalingX: true,
        lockScalingY: true,
        hasControls: false,
      });
      canvas.renderAll();
    }
  };

  const unLockObject = () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      activeObject.set({
        lockMovementX: false,
        lockMovementY: false,
        lockRotation: false,
        lockScalingX: false,
        lockScalingY: false,
        hasControls: true,
      });
      canvas.renderAll();
    }
  };

  return (
    <Menu
      isOpen={isRightMenuOpen}
      onClose={() => {
        setIsRightMenuOpen(false);
      }}
    >
      <MenuList
        onAnimationStart={(e) => {
          const menu = document.querySelector("[role=menu]");
          const popper = menu.parentElement;
          Object.assign(popper.style, {
            top: `${mouseY}px`,
            left: `${mouseX}px`,
          });
        }}
      >
        <MenuItem onClick={deleteItem}>
          <Flex alignItems={"center"} width={"100%"}>
            <HiTrash size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Delete
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={copyItem}>
          <Flex alignItems={"center"} width={"100%"}>
            <IoCopy size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Duplicate
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={objectFitToCanvas}>
          <Flex alignItems={"center"} width={"100%"}>
            <AiOutlineCopy size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Fit To Canvas
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={bringForward}>
          <Flex alignItems={"center"} width={"100%"}>
            <RiBringToFront size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Bring Forward
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={sendBackward}>
          <Flex alignItems={"center"} width={"100%"}>
            <RiSendToBack size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Send Backward
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={onOpen}>
          <Flex alignItems={"center"} width={"100%"}>
            <RxDimensions size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Change Canvas Dimension
            </Text>
          </Flex>
        </MenuItem>
        {/* Modal code Started from here */}
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              <Heading
                color={"black"}
                lineHeight={1.1}
                fontSize={{ base: "2xl", sm: "3xl", md: "3xl" }}
              >
                Canvas Custom
                <Text
                  as={"span"}
                  bgGradient="linear(to-r, red.400,pink.400)"
                  bgClip="text"
                >
                  {" "}
                  Dimension
                </Text>
              </Heading>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <Box as={"form"} mt={5}>
                <Flex gap={10}>
                  <Input
                    placeholder="Canvas Width"
                    bg={"gray.100"}
                    border={0}
                    type="text"
                    color={"black"}
                    _placeholder={{
                      color: "gray",
                    }}
                    name="width"
                    value={addDimension.width}
                    onChange={handleDimension}
                  />
                  <Input
                    placeholder="Canvas Height"
                    bg={"gray.100"}
                    border={0}
                    type="text"
                    color={"black"}
                    _placeholder={{
                      color: "gray.500",
                    }}
                    name="height"
                    value={addDimension.height}
                    onChange={handleDimension}
                  />
                </Flex>
                <Button
                  fontFamily={"heading"}
                  fontWeight={"extrabold"}
                  fontSize={22}
                  m={"auto"}
                  mt={8}
                  bg="#21314a"
                  color={"white"}
                  _hover={{
                    bg: "#21314a",
                    boxShadow: "xl",
                  }}
                  onClick={() =>
                    changeCanvasDimension(
                      addDimension.width,
                      addDimension.height,
                    )
                  }
                >
                  Update Dimension
                </Button>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
        <MenuItem onClick={setBackgroud}>
          <Flex alignItems={"center"} width={"100%"}>
            <BiSolidImageAdd size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Set Background
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={deleteBackground}>
          <Flex alignItems={"center"} width={"100%"}>
            <FcRemoveImage size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Remove Background
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={lockObject}>
          <Flex alignItems={"center"} width={"100%"}>
            <AiFillLock size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Lock Object
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={unLockObject}>
          <Flex alignItems={"center"} width={"100%"}>
            <AiFillUnlock size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Unlock Object
            </Text>
          </Flex>
        </MenuItem>
        <MenuItem onClick={cleanCanvas}>
          <Flex alignItems={"center"} width={"100%"}>
            <MdOutlineCleanHands size={20} color="black" />
            <Text ml={10} fontWeight={"bold"} fontSize={18}>
              Clean Canvas
            </Text>
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ClickMenuList;
